module.exports = __webpack_public_path__ + "img/zj5.08b46733.png";